import React, { FC, memo, useMemo } from 'react';
import { Button } from '~/shared/components/button/button.component';
import { useTranslation } from '~/shared/utils';
import ShoppingCart from '$icons/solidAsh/shopping-cart.svg';

type Props = {
    selectedCount: number;
    canSubmit: boolean;
    isUpdatingBasket: boolean;
    onClick: () => void;
};

const SubmitButton: FC<Props> = memo(({ selectedCount, canSubmit, isUpdatingBasket, onClick }) => {
    const { translate } = useTranslation();

    const submitButtonContent = useMemo(() => {
        if (selectedCount === 0 || !canSubmit) {
            return translate('productDetails.selectSize');
        } else {
            return (
                <>
                    <ShoppingCart />
                    {selectedCount === 1
                        ? translate('productDetails.addSetToBasketSingleItem')
                        : translate('productDetails.addSetToBasketMultipleItems', {
                              count: selectedCount,
                          })}
                </>
            );
        }
    }, [selectedCount, translate, canSubmit]);

    return (
        <Button disabled={isUpdatingBasket} onClick={onClick} centeredText>
            {submitButtonContent}
        </Button>
    );
});

SubmitButton.displayName = 'SubmitButton';
export default SubmitButton;
